<template>
  <div id="introductionPage">
    <div class="backgroundPicture" />
    <div class="agreements">
      <el-button @click="rightsAgreements">权益协议模板</el-button>
    </div>
    <div class="process">
      <el-button @click="processDialog = true">权益领取流程</el-button>
    </div>
    <!--<div class="clause">
      <a id="exemption" @click="pdfPreview('https://pic.xiaobaibao.com/clause/2022/4/5378b26ae80a44999f60d017e7d2aa98.pdf')" >《责任免除条款》</a>
      <a id="tkLink" @click="pdfPreview('https://pic.xiaobaibao.com/clause/2022/4/233d4d6309ae442c83a0b2fbc5308467.pdf')" >《保障条款》</a>
    </div>-->
    <div class="claim space-between">
      <div class="getInterest">
        <el-button @click="getInterest">立即领取权益</el-button>
      </div>
      <div class="loginStatus">
        <el-button @click="logOut">退出</el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="claimDialog"
      width="80%"
      :modal="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :show-close="false"
      center>
      <div class="head">
        <div class="title">温馨提示</div>
        <div class="title-hint">请先校验手机号码再领取权益哦~</div>
      </div>
      <div class="check">
        <el-input type="number" v-model="account" onkeyup="value=value.replace(/[^\d]/g,'')" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" class="account"></el-input>
        <el-button @click="receiveCheck" class="receive">立即领取</el-button>
        <div class="cueWords">
          <div class="prompt">
            <span :class="promptStates"></span>
            <span class="errorPrompt" v-html="errorPrompt">{{errorPrompt}}</span>
          </div>
          <div class="interestsInfo" @click="serviceAgreementPage">
            <div>
              <div>保障号：<span>{{securityNumber}}</span></div>
              <div>保障有效期：<span>{{expiryDate}}</span></div>
            </div>
            <div class="arrow"></div>
          </div>
          <div class="contact">如有疑问请致电：<a href="tel:02082513114" >020-82513114</a></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="processDialog"
      :visible.sync="processDialog"
      width="100%"
      :modal-append-to-body="false"
      center>
      <div class="brokenScreenInsuranceProcess"></div>
    </el-dialog>
  </div>
</template>

<script>
    import gt from "../../../tool/geetest/gt.js";
    export default {
      name: "introductionPage",
      data() {
        return {
          claimDialog: true,
          processDialog: false,
          account: '',
          errorPrompt: '',
          pdfPath: '',
          type: '',
          startTime: '',
          rightsToken: '',
          saleToken: '',
          router: null,
          loginAccount: '',
          promptStates: 'none',
          securityNumber: '',
          expiryDate: '',
        }
      },
      methods: {
        // pdf预览
        pdfPreview(url){
          this.$$.pdfPreview(url);
        },
        // 退出登录
        logOut(){
          let that = this;
          that.$$.confirm({
            message: `您确定退出 ${this.loginAccount} 的登录？`,
            type: "warning",
            onOk: function () {
              localStorage.removeItem('interests_rightsToken'+ that.saleToken);
              localStorage.removeItem('interests_loginAccount'+ that.saleToken);
              localStorage.removeItem('interests_router'+ that.saleToken);
              location.reload();
            }
          });
        },
        //-- 权益协议
        rightsAgreements(){
          this.$router.push({name: 'serviceAgreementPage'});
        },
        //-- 权益协议
        serviceAgreementPage(){
          if (this.saleToken != 'kr7CfMZLMHY77EIHpA3HIg==') return;
          this.$router.push({name: 'serviceAgreementPage', query: {rightsToken: this.rightsToken}});
        },
        //-- 立即领取权益
        getInterest(){
          if (this.$$.isValidObj(this.rightsToken) && this.$$.isValidObj(this.router)){
            // 沃支付 - 碎屏险
            if (this.saleToken == 'kr7CfMZLMHY77EIHpA3HIg==') {
              this.$router.push({name: this.router, query: {rightsToken: this.rightsToken}});
              return;
            }else {
              // 沃支付 - 其他产品（H5投保）
              window.open(this.router);
            }

          }else {
            this.claimDialog = true;
          }
        },
        //-- 手机号校验
        receiveCheck(){
          let that = this;
          const errorMsg = that.validationForm_phone(that.account);
          if(errorMsg != null) return that.errorPrompt = errorMsg;

          //-- 图形验证
          if (!that.$$.isValidObj(that.startTime)) that.geeTestInit();
        },
        //-- 权益登录手机校验
        phoneCheck(){
          let that = this;
          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/member/unicom/check', {phoneNum: that.account, saleToken: that.saleToken, startTime: that.startTime}).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;
            $('.interestsInfo, .contact').hide();
            that.promptStates = 'none';
            this.rightsToken = '';

            if (data.success) {
              const {rightsToken, router} = data.datas;
              that.rightsToken = rightsToken;
              that.router = router;
              that.claimDialog = false;
              that.$message.success('手机权益领取验证通过！您已成为广州米兔网络科技有限公司（www.xiaobaiqianbao.com）的合法会员！');

              //-- 本地缓存 rightsToken
              that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
              that.$$.localStorageSet('interests_loginAccount'+that.saleToken, that.account, 5 * 60 * 1000);
              that.$$.localStorageSet('interests_router'+that.saleToken, router, 5 * 60 * 1000);
              that.loginAccount = this.account;
              $('.loginStatus').show();
            }else {
              that.startTime = '';
              let msgList = '';

              const {msg, code, effectiveDate, expireDate, rightsToken} = data;

              if (that.$$.isValidObj(code)){
                that.securityNumber = code;
                that.expiryDate = effectiveDate.substr(0, 10).replace(new RegExp("-","gm"),".") + '~' + expireDate.substr(0, 10).replace(new RegExp("-","gm"),".");
                that.rightsToken = rightsToken;
                that.promptStates = 'successSymbol';

                $('.interestsInfo').css('display', 'flex');
                $('.contact').show();
                if (that.saleToken == 'kr7CfMZLMHY77EIHpA3HIg=='){
                  $('.arrow').show();
                }
              }else if (msg.includes('您的权益领取申请正在审核中,请耐心等待!')){
                that.promptStates = 'warningSymbol';
                $('.contact').show();
              }

              that.errorPrompt = msg;
            }
          });
        },
        //-- 验证手机号
        validationForm_phone(account){
          if(!this.$$.isValidObj(account)) return "请输入手机号~";
          if(!this.$$.constant.phoneReg.test(account)) return "手机号格式错误，请重新输入！";

          return null;
        },
        //-- 图形验证初始化 API1
        geeTestInit(){
          let that = this;
          init();     // 初始化

          function init() {
            let loading = that.Loading.service({fullscreen: true});
            that.axios.get('/member/geetest/register').then((response) => {
              that.$nextTick(() => loading.close());
              let data = response.data;

              if (data.success) {
                const {gt, challenge, new_captcha, success, startTime} = data.datas;
                that.startTime = startTime;

                initGeetest({
                  gt: gt,
                  challenge: challenge,
                  new_captcha: new_captcha,
                  offline: !success,
                  product: 'bind',
                  width: '18.75rem',
                }, handler);
              }else {
                that.$message.error(data.msg);
              }
            });
          }
          function handler(captchaObj) {
            captchaObj.onReady(function () {
              $("#wait").hide();
              captchaObj.verify();
            }).onSuccess(function () {
              let result = captchaObj.getValidate();
              if (!result) return that.$message.error('请完成验证');

              let params = {
                geetest_challenge: result.geetest_challenge,
                geetest_validate: result.geetest_validate,
                geetest_seccode: result.geetest_seccode,
                startTime: that.startTime,
              };

              validate(params);       // 验证 API2
            }).onClose(function () {
              //-- 极验弹窗关闭 - 清空状态
              that.startTime = '';
              captchaObj.destroy();
            });
          }
          //-- API2
          function validate(params) {
            that.axios.post('/member/geetest/validate', params).then((response) => {
              let data = response.data;

              if (data.success) {
                that.phoneCheck();
              }else {
                that.startTime = '';
                that.$message.error(data.msg);
              }
            });
          }
        },
        pageLoad() {
          let that = this;
          if (that.saleToken == 'kr7CfMZLMHY77EIHpA3HIg==') {
            // 沃支付 - 碎屏险
            $('.agreements, .process').show();
            $('.backgroundPicture').addClass('brokenScreenInsuranceBg');
            $('#introductionPage').css({'padding-bottom':'20px'});
          }else if (that.saleToken == 'kr7CfMZLMHbDv/Tg9aq6Jw==') {
            // 沃支付 - 国任通讯网络安全账户资金损失保险
            $('.backgroundPicture').addClass('guoRenCapitalLossInsuranceBg');
          }else if (that.saleToken == 'kr7CfMZLMHY24bkmYKxSaA==') {
            // 沃支付 - 鼎和个人账户资金损失保险
            $('.backgroundPicture').addClass('dingHeCapitalLossInsuranceBg');
          }else if (that.saleToken == 'kr7CfMZLMHZ9wZkH+aElfg==') {
            // 沃支付 - 华安个人账户资金损失保险
            $('.backgroundPicture').addClass('huaAnCapitalLossInsuranceBg');
          }else if (that.saleToken == 'kr7CfMZLMHYaUDb5trO84w==') {
            // 沃支付 - 鼎和出行无忧综合交通保障
            $('.backgroundPicture').addClass('dingHeTravelInsuranceBg');
          }else if (that.saleToken == 'kr7CfMZLMHb6qy/I2768WQ==') {
            // 沃支付 - 和顺临门保障（含新冠确诊及隔离保障）
            $('.backgroundPicture').addClass('heshunRimmonInsuranceBg');
          }else if (that.saleToken == 'kr7CfMZLMHaYoQsfI2Mv2Q==') {
            // 沃支付 - 华泰人身意外险
            $('.backgroundPicture').addClass('huataiPersonalAccidentInsuranceBg');
          }else if (that.saleToken == 'kr7CfMZLMHbR20jO9NY7Bg==') {
            // 沃支付 - 平安全球交通意外保险
            $('.backgroundPicture').addClass('vehicleAccidentInsurance');
            $('#introductionPage').css({'padding-bottom':'50px'});
          }else if (that.saleToken == 'kr7CfMZLMHZvlOwZN9NDvw==') {
            // 沃支付 - "家财万贯" 家庭财产保险
            $('.backgroundPicture').addClass('wgjcPropertyInsurance');
          }else if (that.saleToken == 'kr7CfMZLMHYQjpHSQqFg0A==') {
            // 沃支付 - 华泰网约车意外及营运中断保险
            $('.backgroundPicture').addClass('wgjcPropertyInsurance');
          }else{
            that.$$.alert({
              message: "链接参数'saleToken' 有误，请重新领取权益!",
              type: 'warning',
              onOk: function () {
                that.$router.go(-1);
              }
            });
          }
        },
      },
      mounted() {
        let that = this;
        that.saleToken = decodeURIComponent(encodeURIComponent(that.$route.query.saleToken).replace(new RegExp("%20","gm"),"%2B"));

        //-- 获取权益数据
        if (!that.$$.isValidObj(that.saleToken)) {
          that.$$.alert({
            message: '链接参数有误，请重新领取权益!',
            type: 'warning',
            onOk: function () {
              that.$router.go(-1);
            }
          });
        }else {
          that.pageLoad();
        }

        // 登录状态 - 本地缓存获取
        const rightsToken = that.$$.localStorageGet('interests_rightsToken'+that.saleToken);
        const loginAccount = that.$$.localStorageGet('interests_loginAccount'+that.saleToken);
        const router = that.$$.localStorageGet('interests_router'+that.saleToken);

        if (that.$$.isValidObj(rightsToken) && that.$$.isValidObj(loginAccount) && that.$$.isValidObj(router)) {
          that.rightsToken = rightsToken;
          that.loginAccount = loginAccount;
          that.router = router;
          that.claimDialog = false;
          $('.loginStatus').show();
          that.$$.localStorageSet('interests_rightsToken'+that.saleToken, rightsToken, 5 * 60 * 1000);
          that.$$.localStorageSet('interests_loginAccount'+that.saleToken, loginAccount, 5 * 60 * 1000);
          that.$$.localStorageSet('interests_router'+that.saleToken, router, 5 * 60 * 1000);
        }else {
          localStorage.removeItem('interests_rightsToken'+that.saleToken);
          localStorage.removeItem('interests_loginAccount'+that.saleToken);
          localStorage.removeItem('interests_router'+that.saleToken);
        }
      }
    }
</script>


<style scoped>
  .none{
    display: none!important;
  }

  #introductionPage{
    position: relative;
    width: 100%;
    max-width: 750px;
    height: 100%;
    overflow: scroll;
    margin: 0 auto;
    padding-bottom: 90px;
  }

  .backgroundPicture{
    width: 100%;
    position: relative;
  }

  .brokenScreenInsuranceBg{
    max-height: 166.375rem;
    padding-top: 355%;
    background: url("../../../../static/images/product/brokenScreenInsurance/brokenScreenInsuranceBg.png") no-repeat center / cover;
  }

  .guoRenCapitalLossInsuranceBg{
    max-height: 102.9rem;
    padding-top: 240%;
    background: url("../../../../static/images/product/bg/guoRenCapitalLossInsuranceBg.png") no-repeat center / cover;
  }

  .dingHeCapitalLossInsuranceBg{
    max-height: 901px;
    padding-top: 263%;
    background: url("../../../../static/images/product/bg/dingHeCapitalLossInsuranceBg.png") no-repeat center / cover;
  }

  .huaAnCapitalLossInsuranceBg{
    max-height: 172.25rem;
    padding-top: 401%;
    background: url("../../../../static/images/product/bg/huaAnCapitalLossInsuranceBg.png") no-repeat center / cover;
  }

  .dingHeTravelInsuranceBg{
    max-height: 112.25rem;
    padding-top: 262%;
    background: url("../../../../static/images/product/bg/dingHeTravelInsuranceBg.png") no-repeat center / cover;
  }

  .heshunRimmonInsuranceBg{
    max-height: 1322px;
    padding-top: 385%;
    background: url("../../../../static/images/product/bg/heshunRimmonInsuranceBg.png") no-repeat center / cover;
  }

  .huataiPersonalAccidentInsuranceBg{
    max-height: 105.75rem;
    padding-top: 247%;
    background: url("../../../../static/images/product/bg/huataiPersonalAccidentInsuranceBg.png") no-repeat center / cover;
  }

  .vehicleAccidentInsurance{
    max-height: 109.25rem;
    padding-top: 255%;
    background: url("../../../../static/images/product/bg/vehicleAccidentInsurance.png") no-repeat center / cover;
  }

  .wgjcPropertyInsurance{
    max-height: 104.9rem;
    padding-top: 245%;
    background: url("../../../../static/images/product/bg/wgjcPropertyInsurance.png") no-repeat center / cover;
  }

  .clause{
    text-align: justify;
    width: 80%;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #CCCCCC;
    padding: 0 0 2px;
    margin: 0 10%;
    position: absolute;
    bottom: 65px;
    left: 0;
  }

  .clause a{
    display: inline;
    color: #ff7052;
  }

  .claim{
    width: 100%;
    padding: 25px 10%;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
  }

  .getInterest{
    flex: 2;
  }

  .claim .getInterest>button,
  .claim .loginStatus>button,
  .receive{
    width: 100%;
    height: 40px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background: #FFC867;
    border-radius: 4px;
    border: none;
    clear: both;
  }

  .loginStatus{
    flex: 1;
    margin-left: 10px;
  }

  /*.loginStatus span{
    display: inline-block;
  }

  .loginStatus .logOut{
    padding-left: 3px;
    font-size: 14px;
    border-bottom: 1px solid #ff7052;
    line-height: 20px;
  }*/

  .el-dialog__wrapper /deep/ .el-dialog{
    margin-top: 30vh!important;
    border-radius: 15px;
    position: relative;
  }

  .el-dialog__wrapper /deep/ .el-dialog__title{
    color: #FA6E50;
    font-size: 16px;
    font-weight: bold;
  }
  .el-dialog__wrapper /deep/ .el-dialog__body{
    padding: 0px!important;
    width: 100%;
    text-align: center;
    position: absolute;
    border-radius: 15px;
    top: 0;
    left: 0;
    background: #ffffff;
  }
  .el-dialog__wrapper /deep/ .el-dialog__headerbtn{
    z-index: 999;
    font-size: 2.5rem;
    top: 10px;
    right: 15px;
  }

  .head{
    width: 100%;
    line-height: 30px;
    border-radius: 15px 15px 0 0;
    padding: 15px 0;
    font-weight: bold;
    /*background: linear-gradient(0deg, #FFF9F8 0%, #FFE3DD 100%);*/
    background: url("../../../../static/images/product/dialogBg.png") no-repeat center / cover;
    letter-spacing: 1px;
  }
  .title{
    color: #FA6E50;
    font-size: 16px;
  }
  .title-hint{
    color: #333333;
    font-size: 14px;
    text-align: center;
  }

  .check{
    padding: 20px 10%;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
  }
  .account /deep/ .el-input__inner{
    text-align: center;
  }
  .receive{
    margin: 15px auto 10px;
  }

  .cueWords{
    display: block;
  }
  .prompt{
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .prompt>span:first-child{
    display: inline-block;
    width: 18px;
    height: 18px;
    margin: 2px 2px 0 0;
  }

  .prompt .successSymbol{
    background: url("../../../../static/images/product/successSymbol.png") no-repeat center /100% 100%;
  }
  .prompt .warningSymbol{
    background: url("../../../../static/images/product/warningSymbol.png") no-repeat center /100% 100%;
  }
  .prompt .errorPrompt{
    max-width: calc(100% - 30px);
    color: #FA6E50;
    font-size: 14px;
    font-weight: bold;
  }
  .prompt .errorPrompt /deep/ a{
    display: inline-block;
    text-decoration: underline;
    color: #1a73e8;
  }

  .contact{
    font-size: 12px;
    color: #999999;
    margin: 20px auto 5px;
    display: none;
  }
  .contact a{
    color: #B98C65;
    display: inline-block;
  }

  .interestsInfo{
    display: none;
    align-items: center;
    font-size: 12px;
    color: #999999;
    background: #FFF0EE;
    text-align: left;
    padding: 6px 10px;
    margin-top: 10px;
    border-radius: 5px;
    position: relative;
  }

  .arrow{
    display: none;
  }
  .arrow:after {
    content: '';
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -5px;
    display: block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #999999;
    border-bottom: 2px solid #999999;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .agreements{
    position: absolute;
    top: 10%;
    left: 0;
    transform: translate(0, -50%);
    background: #FFC867;
    padding: 5px 12px;
    border-radius: 0 15px 15px 0;
  }

  .process{
    position: absolute;
    top: 13%;
    left: 0;
    transform: translate(0, -50%);
    background: #FFC867;
    padding: 5px 12px;
    border-radius: 0 15px 15px 0;
  }

  .agreements,
  .process,
  .loginStatus{
    display: none;
  }

  .agreements .el-button,
  .process .el-button{
    padding: 0;
    color: #ffffff;
    background: #FFC867;
    border: none;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
  }

  .processDialog.el-dialog__wrapper /deep/ .el-dialog{
    /*margin-top: 0vh!important;*/
    height: calc(100% - 100px);
    margin: 50px 0!important;
  }
  .processDialog.el-dialog__wrapper /deep/ .el-dialog__header{
    padding: 0!important;
  }
  .processDialog.el-dialog__wrapper /deep/ .el-dialog__body{
    height: 100%;
    position: relative!important;
    overflow: auto;
  }

  .brokenScreenInsuranceProcess{
    position: relative;
    max-height: 91.43rem;
    padding-top: 214%;
    background: url(../../../../static/images/product/brokenScreenInsurance/brokenScreenInsuranceProcess.png) no-repeat center / cover;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/brokenScreenInsurance/introductionPage.vue